import {IWidgetProvider} from "./types";

let widgetProviders: IWidgetProvider[] = [];

export const setWidgetProviders = (payloadWidgetProviders: IWidgetProvider[]) => {
  widgetProviders = payloadWidgetProviders;
}

export const getWidgetProviders = () => {
  return widgetProviders;
}
